import { wsUrl } from "./client";

export type WsEvent =
  | { type: "ping" }
  | { type: "pong" }
  | { type: "dashboard.update"; payload: unknown }
  | { type: "signals.update"; payload: unknown }
  | { type: "task.update"; payload: unknown }
  | { type: "chat.delta"; sessionId: string; text: string }
  | { type: "chat.tool"; sessionId: string; tool: string; args?: unknown; result?: unknown }
  | { type: "chat.end"; sessionId: string; reason?: string }
  | { type: "autopilot.tick"; payload: unknown };

type Listener = (event: WsEvent) => void;

class WsClient {
  private socket: WebSocket | null = null;
  private listeners = new Set<Listener>();
  private reconnectTimer: number | null = null;

  connect(): void {
    if (this.socket && (this.socket.readyState === WebSocket.OPEN || this.socket.readyState === WebSocket.CONNECTING)) {
      return;
    }
    const url = wsUrl();
    const s = new WebSocket(url);
    s.onopen = () => {
      setInterval(() => {
        if (s.readyState === WebSocket.OPEN) s.send(JSON.stringify({ type: "ping" }));
      }, 25_000);
    };
    s.onmessage = (ev) => {
      try {
        const e = JSON.parse(ev.data) as WsEvent;
        for (const l of this.listeners) l(e);
      } catch {
        /* ignore */
      }
    };
    s.onclose = () => {
      this.socket = null;
      if (this.reconnectTimer === null) {
        this.reconnectTimer = window.setTimeout(() => {
          this.reconnectTimer = null;
          this.connect();
        }, 3000);
      }
    };
    this.socket = s;
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
}

export const wsClient = new WsClient();
